module.exports = __webpack_public_path__ + "static/img/19070B_1_2_R_20230207_fit.fa042da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19070B_1_2_R_20230207_fit.png
// module id = IyqJ
// module chunks = 0